export default "__VITE_ASSET__3duzLTY1__"